import { render, staticRenderFns } from "./CsBadge.vue?vue&type=template&id=ba5f1118&"
import script from "./CsBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsBadge.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports